import request from '@/utils/request'

const downloadBlob = function(content, filename) {
  var fileURL = window.URL.createObjectURL(new Blob([content]));
  var fileLink = document.createElement('a');
  fileLink.href = fileURL;
  fileLink.setAttribute('download', filename);
  document.body.appendChild(fileLink);
  fileLink.click();
}

export function getList (asset, filters = {}, pagination = {}) {
  return request({
    url: '/'+asset,
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (asset, id) {
  return request({
    url: '/'+asset+'/' + id,
    method: 'get'
  })
}

export function upsert (asset, data) {
  var method = 'post'
  var url = '/' + asset
  if (data.id) {
    method = 'put'
    url = '/'+asset+'/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (asset, id) {
  return request({
    url: '/'+asset+'/' + id,
    method: 'delete',
  })
}

export function get (url, filters = {}, pagination = {}) {
  return request({
    url,
    method: 'GET',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function post (url, data) {
  return request({
    url,
    data,
    method: 'POST'
  })
}

export function downloadExcel (url) {
  request.defaults.timeout = request.timeoutrequest; //issue 658
  return request({
    url,
    method: 'get',
    responseType: 'blob',
  })
  .then( response => {
    const filename = response.headers.get("X-Filename")
    downloadBlob(response.data, filename);
  })
  .finally( e =>  { request.defaults.timeout = request.timeoutrequest;}); //issue 658
}